import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { TooltipModule } from 'primeng/tooltip';
import { SharedModule as PrimeSharedModule } from 'primeng/api';
import { AcanSelectComponent } from './acan-select/acan-select.component';
import { FormDrawerComponent } from './form-drawer/form-drawer.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { FormSectionComponent } from './form-section/form-section.component';
import { FormShellComponent } from './form-shell/form-shell.component';

const KIT = [
  AcanSelectComponent,
  FormShellComponent,
  FormSectionComponent,
  FormFieldComponent,
  FormDrawerComponent,
];

/** Shared form building blocks (job form format). Styles live in `_form-kit.scss`, loaded globally. */
@NgModule({
  declarations: KIT,
  imports: [
    CommonModule,
    FormsModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    SidebarModule,
    TooltipModule,
    PrimeSharedModule,
  ],
  exports: [
    ...KIT,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    CheckboxModule,
    DialogModule,
    FileUploadModule,
    InputNumberModule,
    InputSwitchModule,
    TooltipModule,
    PrimeSharedModule,
  ],
})
export class FormKitModule {}
